//Messages
export let ROLLBACK_LIST_REFRESH_WARNING: string = "Are you sure? Refreshing this list will reset the journeys to rollback list.";
export let SPINNER_LOADING_MESSAGE: string = "Please wait..."
//State panel values
export let PANEL_VALUE_JESETTINGS_LIST: string = "jesettingsList";
export let PANEL_VALUE_RESULT_LIST: string = "resultList";
export let PANEL_VALUE_ZIP_UPLOADED: string = "zipUploaded";
export let PANEL_VALUE_FETCHXML: string ="fetchXmlValue";
export let PANEL_VALUE_BULKIMPORTTEXT: string = "bulkimportText";
//Paging
export let PAGING_ITEM_AMOUNT: number = 50


// WEBPACK FOOTER //
// ./source/ts/constants/admintool.ts